import { Component } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Icon from "@mui/material/Icon/Icon";
import Fab from "@mui/material/Fab";
import { searchComponent, setInputSearch } from '../../redux/componentsPark/componentsParkActions'
import { removeSearchHistoryLine, getSearchHistoryType } from '../../redux/searchHistory/searchHistoryActions';
import { connect } from 'react-redux';
import Button from "@mui/material/Button/Button";
import TableWithoutPagination from "../Table/TableWithoutPagination"
import { TYPING_TIMEOUT } from '../../constants'
import TextFieldWithTypingTimeout from '../Input/TextFieldWithTypingTimeout';
import { EQUIPMENT_CODE } from '../../redux/searchHistory/searchHistoryConstants';

class ManualSearchTab extends Component {
    constructor(props) {
        super(props);

        this.state = {
            componentCode: "",
            columns: [
                {
                    Header: "Historique de recherche",
                    minWidth: 150,
                    Cell: ({row}) => {
                        let currentHistoryLine = this.props.searchHistory[row.index];

                        if (!currentHistoryLine)
                            return null

                        return (
                            <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding" onClick={this.searchComponent.bind(this, currentHistoryLine)}>
                                <div className="row col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
                                    <span>{currentHistoryLine.searchInput}</span>
                                </div>
                            </div>
                        )
                    }
                }, {
                    Header: "Supprimer de l'historique",
                    maxWidth: 200,
                    Cell: ({row}) => {
                        let currentHistoryLine = this.props.searchHistory[row.index];

                        if (!currentHistoryLine)
                            return null

                        return (
                            <Button onClick={this.removeSearchHistoryLine.bind(this, currentHistoryLine)} color="primary"
                                className="offset-lg-12 offset-md-12 offset-sm-12 offset-12 col-lg-12 col-md-12 col-sm-12 col-12 small-btn without-padding without-side-margin" >
                                <Icon className="small-icon">delete</Icon>
                            </Button>
                        )
                    }
                },
            ]
        }

        this.handleSearchClick = this.handleSearchClick.bind(this);
        this.handleComponentCodeChange = this.handleComponentCodeChange.bind(this);
    }

    static getDerivedState(nextProps, prevState) {

        let modifiedState = prevState;

        if (nextProps.inputSearch !== prevState.componentCode)
            modifiedState.componentCode = nextProps.inputSearch

        return modifiedState;
    }

    searchComponent(currentHistoryLine) {
        this.props.searchEquipment(currentHistoryLine.searchInput);
    }

    removeSearchHistoryLine(historyLine) {
        this.props.removeSearchHistoryLine(getSearchHistoryType(EQUIPMENT_CODE), historyLine);
    }

    handleSearchClick(e) {
        e.preventDefault();

        if (this.state.componentCode !== null)
            this.props.searchEquipment(this.state.componentCode);
    }

    getTableTrProps(row) {
        if (row) {
            return {

            }
        } else {
            return {}
        }
    }

    setInputSearch() {
        this.props.setInputSearch(this.state.componentCode);
    }

    handleComponentCodeChange(value) {
        clearTimeout(this.timer);

        this.setState({
            componentCode: value
        });

        this.timer = setTimeout(this.setInputSearch.bind(this), TYPING_TIMEOUT);
    }

    render() {

        return (
            <Card className="card col-lg-12 col-md-12 col-sm-12 col-12 card-fluide without-side-margin">
                <CardContent className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
                    <div className="offset-lg-2 col-lg-8 offset-md-2 col-md-8 col-sm-12 col-12 without-side-padding">
                        <div className="row div-center">
                            <form onSubmit={this.handleSearchClick.bind(this)} className="col-lg-12 col-md-12 col-sm-12 col-12">
                                <TextFieldWithTypingTimeout className="textField col-lg-6 col-md-6 col-sm-6 col-7"
                                    onValueChange={this.handleComponentCodeChange.bind(this)} value={this.state.componentCode} label="Code équipement" />
                                <Fab variant="extended" type="submit" className="col-lg-3 col-md-4 col-sm-6 col-5" color="secondary">
                                    <Icon>search</Icon>
                                    Rechercher
                                </Fab>
                            </form>
                        </div>
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-12 control-margin-top">
                        <TableWithoutPagination
                            data={this.props.searchHistory}
                            columns={this.state.columns}
                            minRows={5}
                        />
                    </div>
                </CardContent>
            </Card>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        inputSearch: state.componentsPark.inputSearch,
        searchHistory: state.searchHistory.searchHistory,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        searchComponent: (code) => dispatch(searchComponent(code)),
        setInputSearch: (inputSearch) => dispatch(setInputSearch(inputSearch)),
        removeSearchHistoryLine: (type, historyLine) => dispatch(removeSearchHistoryLine(type, historyLine)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ManualSearchTab);
